export default __webpack_public_path__ + "static/media/bookGreen.79a9048b.svg";